export const GET_BULKPAYMENT_LIST = 'SHOP/GET_BULKPAYMENT_LIST';
export const GET_BULKPAYMENT_LIST_SUCCESS = 'SHOP/GET_BULKPAYMENT_LIST_SUCCESS'
export const GET_BULKPAYMENT_LIST_FAILED = 'SHOP/GET_BULKPAYMENT_LIST_FAILED'
export const GET_SINGLE_BULKPAYMENT_LIST = 'SHOP/GET_SINGLE_BULKPAYMENT_LIST';
export const GET_SINGLE_BULKPAYMENT_LIST_SUCCESS = 'SHOP/GET_SINGLE_BULKPAYMENT_LIST_SUCCESS'
export const GET_SINGLE_BULKPAYMENT_LIST_FAILED = 'SHOP/GET_SINGLE_BULKPAYMENT_LIST_FAILED'
export const GET_CHECKERS_LIST = 'SHOP/GET_CHECKERS_LIST';
export const GET_CHECKERS_LIST_SUCCESS = 'SHOP/GET_CHECKERS_LIST_SUCCESS'
export const GET_CHECKERS_LIST_FAILED = 'SHOP/GET_CHECKERS_LIST_FAILED'
export const CLOSE_SINGLE_BULK_MODAL = "SHOP/CLOSE_SINGLE_BULK_MODAL"